import React from 'react';
import { PortalContext } from '../context/portal-context';
import { AddVehiclePending } from '../components/vehicle-manager/components/add-vehicle-pending';
import { useUniversalEffect } from '@volkswagen-onehub/vw-starter-feature-app-support';
import { usePageTracker } from '../hooks/use-page-tracker';
import { Vehicle } from '@esportal/portal-service';
import { ClubVolkswagenPages, ClubVolkswagenPagesInfo } from './model/club-volkswagen-pages-info';

export const AddVehiclePendingPage: React.FC<{
	vehicle: Vehicle | undefined;
}> = ({ vehicle }) => {
	const { pageInfoService } = React.useContext(PortalContext);
	const pageInfo = ClubVolkswagenPagesInfo[ClubVolkswagenPages.AddVehiclePendingPage];

	useUniversalEffect(() => {
		pageInfoService.setPageInfo({
			seo: { pageTitle: pageInfo.seoTitle },
		});
	}, [pageInfoService]);

	usePageTracker({ contentId: pageInfo.contentId, vehicle: vehicle ? [vehicle] : undefined });

	return <AddVehiclePending plate={vehicle?.vgedRegistrationPlate ?? ''} />;
};
